module.exports = __webpack_public_path__ + "media/site/images/voicetalents-berlin_logo-8228859ad52cb450cb7fa16779146913.png";